import { render, staticRenderFns } from "./EmpresaForm.vue?vue&type=template&id=40a2f49d"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"
import style0 from "./EmpresaForm.vue?vue&type=style&index=0&id=40a2f49d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports